import { useState } from 'preact/hooks';
import {
  activeChatId,
  addMember,
  chatDisplayName,
  chats,
  closeChat,
  removeMember,
  rekeyChat,
  session,
  syncAll,
} from '../lib/engine.js';
import { api } from '../lib/api.js';
import { back, go } from './nav.js';

export function ChatInfo() {
  const chatId = activeChatId.value!;
  const chat = chats.value.find((row) => row.id === chatId);
  const [busy, setBusy] = useState<string | null>(null);
  const [newMember, setNewMember] = useState('');
  const [error, setError] = useState<string | null>(null);

  if (!chat) return null;

  const isAdmin = chat.role === 'admin';
  const me = session.value!.userId;

  const guard = async (label: string, action: () => Promise<void>) => {
    setBusy(label);
    setError(null);
    try {
      await action();
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : 'Не получилось');
    } finally {
      setBusy(null);
    }
  };

  return (
    <div class="screen">
      <header class="topbar">
        <button class="icon-btn" onClick={back} aria-label="Назад">
          ‹
        </button>
        <h1>{chatDisplayName(chat)}</h1>
      </header>

      <div class="scroll">
        {error && (
          <div class="section">
            <div class="error">{error}</div>
          </div>
        )}

        <div class="section">
          <h2>Участники</h2>
          {chat.members.map((member) => (
            <div class="row" key={member.id}>
              <div>
                <div>{member.displayName}</div>
                <div class="preview">@{member.username}</div>
              </div>
              {isAdmin && chat.kind === 'group' && member.id !== me && (
                <button
                  class="btn danger"
                  disabled={busy !== null}
                  onClick={() =>
                    guard('remove', async () => {
                      await removeMember(chatId, member.id);
                    })
                  }
                >
                  Исключить
                </button>
              )}
            </div>
          ))}
        </div>

        {isAdmin && chat.kind === 'group' && (
          <div class="section">
            <h2>Добавить участника</h2>
            <div class="row">
              <input
                class="mono"
                style="flex:1"
                value={newMember}
                onInput={(event) => setNewMember((event.target as HTMLInputElement).value)}
                autocapitalize="none"
                spellcheck={false}
                placeholder="имя пользователя"
              />
              <button
                class="btn"
                disabled={busy !== null || !newMember.trim()}
                onClick={() =>
                  guard('add', async () => {
                    await addMember(chatId, newMember);
                    setNewMember('');
                  })
                }
              >
                Добавить
              </button>
            </div>
            <div class="notice">
              Новому участнику отдаётся ключ текущей эпохи: он увидит переписку с последней
              смены ключа, но не раньше. Чтобы закрыть и её, смени ключ до добавления.
            </div>
          </div>
        )}

        <div class="section">
          <h2>Уведомления</h2>
          <div class="row">
            <span>{chat.muted ? 'Отключены для этого чата' : 'Включены'}</span>
            <button
              class="btn subtle"
              disabled={busy !== null}
              onClick={() =>
                guard('mute', async () => {
                  await api.setMuted(chatId, !chat.muted);
                  await syncAll();
                })
              }
            >
              {chat.muted ? 'Включить' : 'Отключить'}
            </button>
          </div>
        </div>

        <div class="section">
          <h2>Безопасность</h2>
          <div class="row">
            <span>Эпоха ключа: {chat.keyEpoch}</span>
            <button
              class="btn subtle"
              disabled={busy !== null}
              onClick={() =>
                guard('rekey', async () => {
                  await rekeyChat(chatId);
                })
              }
            >
              {busy === 'rekey' ? 'Меняю…' : 'Сменить ключ'}
            </button>
          </div>
          <div class="notice">
            Смена ключа создаёт новую эпоху: всё написанное после неё шифруется новым ключом.
            Прежняя переписка остаётся на старом и у участников не пропадает. Делай это, если
            подозреваешь, что чьё-то устройство скомпрометировано.
          </div>
        </div>

        {chat.kind === 'group' && (
          <div class="section">
            <button
              class="btn danger"
              disabled={busy !== null}
              onClick={() =>
                guard('leave', async () => {
                  await api.removeMember(chatId, me);
                  closeChat();
                  await syncAll();
                  go('chats');
                })
              }
            >
              Покинуть группу
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
